export default __webpack_public_path__ + "static/media/twitter.b5bff60e.svg";